import axios from 'axios'
import {serialize} from '../../../core/_util'
const API_URL = process.env.REACT_APP_BASE_API_URL

const GET_DASHBOARD_STATISTICS = `${API_URL}/statistics`
const GET_DASHBOARD_ACTIVITY = `${API_URL}/activity/dashboard`
const GET_EARLY_OFFER = `${API_URL}/early-access`
const GET_SUCCESS_GUIDE = `${API_URL}/success-guide-details`
const GET_REACTIVATE_SUBSCRIPION = `${API_URL}/billing/reactivate-subscription`

export const getDashboardStatistics = (
  companyId: number,
  actualMonth: string,
  compareMonth: string
) => {
  const object = {
    actualMonth,
    compareMonth,
  }
  return axios.get(`${GET_DASHBOARD_STATISTICS}/${companyId}?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getDashboardActivity = (companyId: number) => {
  return axios.get(`${GET_DASHBOARD_ACTIVITY}/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getEarlyOffer = (payload: any) => {
  return axios.post(`${GET_EARLY_OFFER}/offer`, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const getEarlyOfferStatus= (companyId: number) => {
  return axios.get(`${GET_EARLY_OFFER}/offer`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const sendEarlyInvite = (payload: any) => {
  return axios.post(`${GET_EARLY_OFFER}/invite`, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const getInvitees= (companyId: number) => {
  return axios.get(`${GET_EARLY_OFFER}/invitees`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getSuccessGuide= (companyId: number) => {
  return axios.get(`${GET_SUCCESS_GUIDE}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}


export const getReactivateSubscriptionDetails= (companyId: number) => {
  return axios.get(`${GET_REACTIVATE_SUBSCRIPION}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}
